import { gql, DocumentNode } from '@apollo/client';
import { Box } from '@mui/material';
import React from 'react';
import {
	InvoiceEditLineItemSummary,
	InvoiceEditLineItemSummaryProps,
} from './InvoiceEditLineItemSummary';
import { InvoiceEditNotes, InvoiceEditNotesProps } from './InvoiceEditNotes';
import styles from './InvoiceEditNotesAndLineItemSummary.module.scss';
import { InvoiceEditNotesAndLineItemSummaryInvoiceFragment } from '#types';
import {
	InvoiceEditFileSelector,
	InvoiceEditFileSelectorProps,
} from './InvoiceEditFileSelector';

const invoiceEditNotesAndLineItemSummaryInvoiceFragment = gql`
	fragment invoiceEditNotesAndLineItemSummaryInvoice on Invoice {
		...invoiceEditNotesInvoice
		...invoiceEditLineItemSummaryInvoice
	}
	${ InvoiceEditNotes.fragments.invoiceEditNotesInvoiceFragment }
	${ InvoiceEditLineItemSummary.fragments
		.invoiceEditLineItemSummaryInvoiceFragment }
`;

export type InvoiceEditNotesAndLineItemSummaryProps = Pick<
InvoiceEditFileSelectorProps,
| 'filename'
| 'file'
| 'setFile'
| 'isUploading'
| 'intentToChangeOrDeleteCurrentAttachmentFile'
| 'setIntentToChangeOrDeleteCurrentAttachmentFile'
> & {
	invoice?: Omit<InvoiceEditNotesAndLineItemSummaryInvoiceFragment, 'id'> & {
		id?: string;
	};
	setInvoice: React.Dispatch<
	React.SetStateAction<
	Omit<InvoiceEditNotesAndLineItemSummaryInvoiceFragment, 'id'> & {
		id?: string;
	}
	>
	>;
	fileValidation?: string;
};

type InvoiceEditNotesAndLineItemSummaryPropsWithFragment =
	React.FC<InvoiceEditNotesAndLineItemSummaryProps> & {
		fragments: {
			invoiceEditNotesAndLineItemSummaryInvoiceFragment: DocumentNode;
		};
	};

export const InvoiceEditNotesAndLineItemSummary: InvoiceEditNotesAndLineItemSummaryPropsWithFragment =
	( { invoice, setInvoice, fileValidation, ...fileSelectorProps } ) => (
		<Box className={ styles.container }>
			<InvoiceEditNotes
				className={ styles.notes }
				invoice={ invoice }
				setInvoice={ setInvoice as InvoiceEditNotesProps['setInvoice'] }
			/>
			<InvoiceEditFileSelector
				className={ styles.attachment }
				invoice={ invoice }
				errorText={ fileValidation }
				{ ...fileSelectorProps }
			/>
			<InvoiceEditLineItemSummary
				className={ styles.lineItemSummary }
				invoice={ invoice }
				setInvoice={ setInvoice as InvoiceEditLineItemSummaryProps['setInvoice'] }
			/>
		</Box>
	);

InvoiceEditNotesAndLineItemSummary.fragments = {
	invoiceEditNotesAndLineItemSummaryInvoiceFragment,
};
